import { Component, Input, ViewEncapsulation } from '@angular/core';
import { TagVariantType } from './models/tag';

@Component({
  selector: 'app-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.styl'],
  encapsulation: ViewEncapsulation.None
})
export class AppTagComponent {
  @Input() label: string;
  @Input() variant: TagVariantType = 'green';

  constructor() { }

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/components/tag/tag.component.ts